import React, { useMemo } from 'react';
import styles from './ClientAddresseRow.module.scss';
import { Form } from 'antd';
import DropdownSelect from '../../../dropdownSelect';
import useRequestAddresses from '../../../../queries/useRequestAddresses';
import { getRenderControl } from '../../../SingleControlCustom/getRenderControl';
import { getOptionsSelect } from '../../lib/getOptionsSelect';
import useClientsByAddressQuery from '../../api/query/useClientsByAddressQuery';
import { getDocOptionsSelectStreet } from '../../lib/getDocOptionsSelectStreet';
import useHouseAvailableQuery from '../../../../queries/useHouseAvailableQuery';
import useStreetsAvailableQuery from '../../../../queries/useStreetsAvailableQuery';
import { modeRequest } from '../../../../constants/modeRequest';

const ClientAddresseRow = ({ form, companyId, addFromPermit, valueForTs }) => {
  const streetIdValue = form.getFieldValue('streetId');
  const houseIdValue = form.getFieldValue('houseId');
  const addressIdValue = form.getFieldValue('addressId');
  const clientIdValue = form.getFieldValue('clientId');

  const { data: steets = [], isFetching: isStreetsFetching } =
    useStreetsAvailableQuery(
      { companyId, mode: modeRequest.TRANSPOR },
      { staleTime: Infinity, enabled: !!companyId }
    );

  const { data: houses = [], isFetching: isHouseFetching } =
    useHouseAvailableQuery(
      { companyId, mode: modeRequest.TRANSPOR, streetId: streetIdValue },
      { staleTime: Infinity, enabled: Boolean(streetIdValue) }
    );

  const { data: flats = [], isFetching: isFlatFetching } = useRequestAddresses(
    houseIdValue,
    {
      enabled: Boolean(houseIdValue && streetIdValue),
    }
  );
  const { data: clients, isFetching: isFetchingClients } =
    useClientsByAddressQuery(addressIdValue, { enabled: !!addressIdValue });

  const optionsSteets = useMemo(
    () => getDocOptionsSelectStreet(steets),
    [steets]
  );
  const optionsHouses = useMemo(
    () => getOptionsSelect({ data: houses }),
    [houses]
  );
  const optionsFlats = useMemo(
    () => getOptionsSelect({ data: flats, isFlat: true }),
    [flats]
  );
  const optionsClient = useMemo(
    () => getOptionsSelect({ data: clients, isClient: true }),
    [clients]
  );

  const changeStreet = () => {
    form.setFieldsValue({
      addressId: null,
      clientId: null,
      houseId: null,
    });
  };

  const changeHouse = () => {
    form.setFieldsValue({
      addressId: null,
      clientId: null,
    });
  };

  const changeAddress = () => {
    form.setFieldsValue({
      clientId: null,
    });
  };

  return (
    <div className={styles.root}>
      <Form.Item label="Улица" style={{ margin: 0, flex: 1 }}>
        {form.getFieldDecorator('streetId', {
          initialValue: addFromPermit ? valueForTs?.streetId : undefined,
          rules: [
            {
              required: true,
              message: 'Пожалуйста, укажите улицу',
            },
          ],
        })(
          <DropdownSelect
            onChange={changeStreet}
            multiple={false}
            options={optionsSteets}
            renderControl={getRenderControl({
              options: optionsSteets,
              isClear: false,
              value: streetIdValue,
              placeholder: 'Выберите из списка',
              disabled: isStreetsFetching || addFromPermit,
              loading: isStreetsFetching,
            })}
          />
        )}
      </Form.Item>
      <Form.Item label="Дом" style={{ margin: 0, flex: 1 }}>
        {form.getFieldDecorator('houseId', {
          initialValue: addFromPermit ? valueForTs?.houseId : undefined,
          rules: [
            {
              required: true,
              message: 'Пожалуйста, укажите дом',
            },
          ],
        })(
          <DropdownSelect
            onChange={changeHouse}
            multiple={false}
            options={optionsHouses}
            renderControl={getRenderControl({
              options: optionsHouses,
              isClear: false,
              value: houseIdValue,
              placeholder: '№',
              disabled: isHouseFetching || !streetIdValue || addFromPermit,
              loading: isHouseFetching,
            })}
          />
        )}
      </Form.Item>
      <Form.Item label="Помещение" style={{ margin: 0, flex: 1 }}>
        {form.getFieldDecorator('addressId', {
          initialValue: addFromPermit ? valueForTs?.addressId : undefined,
          rules: [
            {
              required: true,
              message: 'Пожалуйста, укажите помещение',
            },
          ],
        })(
          <DropdownSelect
            onChange={changeAddress}
            multiple={false}
            options={optionsFlats}
            renderControl={getRenderControl({
              options: optionsFlats,
              isClear: false,
              value: addressIdValue,
              placeholder: 'Кв./офис',
              disabled: isFlatFetching || !houseIdValue || addFromPermit,
              loading: isFlatFetching,
            })}
          />
        )}
      </Form.Item>
      <Form.Item label="Клиент" style={{ margin: 0, flex: 1 }}>
        {form.getFieldDecorator('clientId', {
          initialValue: addFromPermit ? valueForTs?.clientId : undefined,
          rules: [
            {
              required: true,
              message: 'Пожалуйста, укажите клиента',
            },
          ],
        })(
          <DropdownSelect
            multiple={false}
            options={optionsClient}
            renderControl={getRenderControl({
              options: optionsClient,
              isClear: false,
              value: clientIdValue,
              placeholder: 'Выберите из списка',
              disabled: isFetchingClients || !addressIdValue || addFromPermit,
              loading: isFetchingClients,
            })}
          />
        )}
      </Form.Item>
    </div>
  );
};

export default ClientAddresseRow;
